module.exports = __webpack_public_path__ + "static/media/baseline.7b13f90b.svg";